import {Component, Pipe, PipeTransform, Injectable} from '@angular/core';
import { Park } from '../../dataTypes/Park';

@Pipe({
  name: 'destinedParkTranslate',
    pure: false
})
@Injectable()
export class destinedParkTranslatePipe implements PipeTransform {

  transform(filter: number, items: Park[]): string {
        if (!items) return '';
        if (!filter) return '';
        if (filter===0) return '';

    var t = items.find(x => x.id === filter);
      if (t) {
        return t.parkDescription;
      }
      else
        return '';

      
    }
}
